// Simulate a long task
// 模拟一个长任务
let p = 1000
while (p >= 0) {
  console.log("模拟一个长任务")
  p--
}